import { createSlice } from '@reduxjs/toolkit';

import { requestProducts } from 'src/redux/products/thunks/requestProducts';
import { TriggerName } from 'src/redux/products/types';
import { getProductPageStartAndEndIndex } from './utils';

const triggerIsPagination = (triggerName?: TriggerName) => {
  return (
    triggerName === TriggerName.LOAD_MORE_PRODUCTS ||
    triggerName === TriggerName.LOAD_PREVIOUS_PRODUCTS
  );
};

const triggerIsFacetOrSort = (triggerName?: TriggerName) => {
  return (
    triggerName === TriggerName.CHANGE_FACETS ||
    triggerName === TriggerName.CHANGE_SORT ||
    triggerName === TriggerName.PAGE_NUMBER_CHANGE ||
    triggerName === TriggerName.RESET_ALL_FACETS_AND_SORT ||
    triggerName === TriggerName.RESET_FACET
  );
};

export interface AccessibilityState {
  statusMessage: string;
}

export const initialState: AccessibilityState = {
  statusMessage: '',
};

export const { actions, reducer } = createSlice({
  name: 'accessibility',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(requestProducts.pending, (state, { meta }) => {
        if (triggerIsPagination(meta.arg.triggerName)) {
          state.statusMessage = 'Loading more products';
        }

        if (triggerIsFacetOrSort(meta.arg.triggerName)) {
          state.statusMessage = 'Loading products';
        }
      })
      .addCase(requestProducts.fulfilled, (state, { meta, payload }) => {
        if (triggerIsPagination(meta.arg.triggerName) && payload.products) {
          const { lastPageLoaded, perPage, products } = payload.products;
          const { end, start } = getProductPageStartAndEndIndex(
            perPage,
            lastPageLoaded,
            products.length,
          );

          state.statusMessage = `Products ${start} to ${end} loaded`;
        }

        if (triggerIsFacetOrSort(meta.arg.triggerName)) {
          state.statusMessage = `Products loaded`;
        }
      })
      .addCase(requestProducts.rejected, (state, { meta }) => {
        if (triggerIsPagination(meta.arg.triggerName)) {
          state.statusMessage = 'There was a problem loading more products';
        }

        if (triggerIsFacetOrSort(meta.arg.triggerName)) {
          state.statusMessage = 'There was a problem loading products';
        }
      });
  },
});
